/**
 * Search results view mode — parse, resolve, URL sync (Milestone 6).
 */
import {
  AUTOMAPA_SEARCH_MAP_ENABLED,
  SEARCH_RESULTS_VIEW_MODE,
} from "../../constants/automapSearchMapListConstants";

export function normalizeSearchResultsViewMode(value) {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (raw === SEARCH_RESULTS_VIEW_MODE.MAP) return SEARCH_RESULTS_VIEW_MODE.MAP;
  if (raw === SEARCH_RESULTS_VIEW_MODE.SPLIT) return SEARCH_RESULTS_VIEW_MODE.SPLIT;
  return SEARCH_RESULTS_VIEW_MODE.LIST;
}

/**
 * Effective buyer-facing mode after feature flag and viewport rules.
 * @param {string|null|undefined} requested
 * @param {{ isMobile?: boolean, mapEnabled?: boolean }} [options]
 * @returns {import('../../constants/automapSearchMapListConstants').SearchResultsViewMode}
 */
export function resolveEffectiveSearchViewMode(
  requested,
  { isMobile = false, mapEnabled = AUTOMAPA_SEARCH_MAP_ENABLED } = {}
) {
  const mode = normalizeSearchResultsViewMode(requested);
  if (!mapEnabled) return SEARCH_RESULTS_VIEW_MODE.LIST;
  if (isMobile && mode === SEARCH_RESULTS_VIEW_MODE.SPLIT) {
    return SEARCH_RESULTS_VIEW_MODE.LIST;
  }
  return mode;
}

export function isSearchMapViewActive(viewMode) {
  return (
    viewMode === SEARCH_RESULTS_VIEW_MODE.MAP || viewMode === SEARCH_RESULTS_VIEW_MODE.SPLIT
  );
}

export function parseSearchViewModeFromParams(searchParams) {
  const sp =
    searchParams instanceof URLSearchParams
      ? searchParams
      : new URLSearchParams(searchParams || "");
  return normalizeSearchResultsViewMode(sp.get("view"));
}

export function serializeSearchViewModeParam(viewMode) {
  const mode = normalizeSearchResultsViewMode(viewMode);
  if (!AUTOMAPA_SEARCH_MAP_ENABLED || mode === SEARCH_RESULTS_VIEW_MODE.LIST) {
    return null;
  }
  return mode;
}

/**
 * Clear selected listing when it is no longer in the visible result set.
 * @param {string|null} selectedListingId
 * @param {Array<{ id?: string }>} visibleListings
 */
export function resolveSelectedListingId(selectedListingId, visibleListings = []) {
  if (!selectedListingId) return null;
  const stillVisible = visibleListings.some((listing) => listing.id === selectedListingId);
  return stillVisible ? selectedListingId : null;
}
